// Process External Links

jQuery( function ( $ ) {
    $( 'a' ).filter( function () {
        return this.hostname && this.hostname !== location.hostname;
    } ).addClass( "external" );

    // Open External Links in new tab
    $( 'a.external' ).attr( 'target', '_blank' );
} );